<template>
  <div>
    <Mainl @mlogin="mlogin" @scrollTo="scrollTo"></Mainl>
    <div class="page_content">
      <div class="case_detail_breadcrumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item><a href="/servicecaselist" style="color: rgba(19,20,28,0.6);font-weight: 500;">案例库</a></el-breadcrumb-item>
          <el-breadcrumb-item><a style="color: rgba(19,20,28,0.9);font-weight: 700;">{{case_id != '' ? '编辑案例' : '上传案例'}}</a></el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="change_password_content" style="height: auto;">
        <div class="change_password_content_title">{{case_id != '' ? '编辑案例' : '上传案例'}}</div>
        <div class="change_password_content_form_wrap">
          <el-form ref="ruleForm" :model="ruleForm" label-width="120px" class="demo-ruleForm">
            <div class="form_row">
              <el-form-item label="项目名称" prop="name" :rules="[ { required: true, message: '请输入项目名称', trigger: ['blur', 'change']}, ]">
                <el-input placeholder="请输入项目名称" style="width: 336px;" type="text" v-model="ruleForm.name" ></el-input>
              </el-form-item>
              <el-form-item label="项目周期" prop="cycle" :rules="[ { required: true, message: '请输入项目周期', trigger: ['blur', 'change']}, ]">
                <el-input placeholder="请输入项目周期" style="width: 336px;" type="text" v-model="ruleForm.cycle" ></el-input>
              </el-form-item>
            </div>
            <div class="form_row">
              <el-form-item label="项目金额" prop="money" :rules="[ { required: true, message: '请选择项目金额', trigger: ['blur', 'change']}, ]">
                <el-select style="width: 334px;" v-model="ruleForm.money" placeholder="请选择项目金额">
                  <el-option :key="key" :label="item" :value="key" v-for="(item,key) in xy_case_money_dict">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="客户品牌" prop="brand_name" :rules="[ { required: true, message: '请填写客户品牌', trigger: ['blur', 'change']}, ]">
                <el-input placeholder="请填写客户品牌" style="width: 336px;" type="text" v-model="ruleForm.brand_name" ></el-input>
              </el-form-item>
            </div>
            <el-form-item label="所属行业" prop="industry_second_id" :rules="[{ required: true, message: '请选择所属行业', trigger: ['change']}, ]">
              <!--  // 之前是二级单选
              <el-cascader
                  v-model="industry_info"
                  :options="industry_dic"
                  @change="industryChange"
                  placeholder="请选择所属行业"
                  style="width: 100%;"
              ></el-cascader>
              -->
              <!-- 现在改为 一级多选 -->
              <el-select v-model="industry_info" multiple placeholder="请选择所属行业" style="width: 100%;" @change="industryChange" clearable>
                <el-option
                    v-for="item in industry_dic"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="所属创意类目" prop="category_second_id" :rules="[ { required: true, message: '请选择所属创意类目', trigger: ['blur', 'change']}, ]">
              <!-- collapse-tags -->
              <el-cascader
                  v-model="category_info"
                  :options="category_dic"
                  @change="categoryChange"
                  :props="{ multiple: true }"
                  placeholder="请选择所属创意类目"
                  clearable
                  style="width: 100%;"
              ></el-cascader>
            </el-form-item>
            <el-form-item label="服务内容" prop="service_content" :rules="[ { required: true, message: '请填写服务内容', trigger: ['blur', 'change']}, ]">
              <el-input v-model="ruleForm.service_content" style="width: 100%;height: 240px;" resize="none" type="textarea" :rows="11" placeholder="请输入该案例中您所提供的服务内容，包括项目背景、客户要求、成果及客户满意度等。填写后将展示在案例详情中供需求方查看">
              </el-input>
            </el-form-item>
            <div class="service_register_upload__wrap">
              <el-form-item label="上传封面">
                <!-- 新弹框上传封面 -->
                <div class="service_register_upload" @click="onEditImg">
                  <i class="el-icon-circle-plus"></i>
                  <span>上传封面图</span>
                  <span class="service_register_upload_tip">请上传16:9比例的封面图
                    支持JPG/PNG文件
                    大小不超过10M</span>
                </div>
                <!-- // 组件上传封面
                <el-upload class="myupload"
                           drag
                           action=""
                           :auto-upload="true"
                           :on-change="handleCrop"
                           :before-upload="beforeAvatarUpload"
                           :disabled="false"
                           :limit="1"
                           accept=".png,.jpg,.jpeg"
                           :data="{type:0, upload_type: '2'}"
                           list-type="picture-card"
                >
                  <div slot="trigger" class="service_register_upload">
                    <i style="color: #4573FF;" class="el-icon-circle-plus"></i>
                    <span>上传封面图</span>
                    <span class="service_register_upload_tip">封面图推荐尺寸1280*720，支持JPG/JPEG/PNG文件，大小不超过10M</span>
                  </div>
                </el-upload>
                <CropperImage
                    :dialogVisible="showCropper"
                    :cropper-option="cropperOption"
                    :cover-file-info="coverFileInfo"
                    :file-size="fileSize"
                    :cropper-style="cropperStyle"
                    @close="showCropper=false"
                    @uploadCropper="uploadImg"></CropperImage>
                    -->

                <!-- // 非弹框上传封面
                <el-upload
                    name="files"
                    class="upload-demo"
                    :on-change="(file, fileList) => handleFileChange(2, file, fileList)"
                    :data="{upload_type: '2'}"
                    :on-success="(res, file, fileList) => handleFIleSuccess(2, res, file, fileList)"
                    :before-upload="(file) => beforeFileUpload(2, file)"
                    :before-remove="(file, fileList) => removeFileUpload(2, file, fileList)"
                    :on-preview="mi_upload_handlepreview"
                    :on-exceed="(files, fileList) => overFilelimit(2, files, fileList)"
                    :file-list="coverArr"
                    :action="pubPrefix+upload_url"
                    :headers="upload_headers"
                    :limit="1"
                    :show-file-list=false
                    accept="image/jpg, image/png, image/jpeg"
                    >
                  <div slot="trigger" class="service_register_upload">
                    <i class="el-icon-circle-plus"></i>
                    <span>上传封面图</span>
                    <span class="service_register_upload_tip">请上传尺寸为1280×720的封面图，支持JPG/JPEG/PNG文件，大小不超过10M</span>
                  </div>
                </el-upload>
                -->
              </el-form-item>
              <div class="service_register_upload_item_wrap" v-show="cover_url != ''">
                <el-image :src="cover_url" class="service_register_upload_demo" :preview-src-list="[cover_url]">
                </el-image>
                <span @click="onDelete(2)" class="service_register_upload_item_delete"><img :src="require('@/assets/img/icon_off_deep.png')"/></span>
              </div>
            </div>
            <div class="service_register_upload_imgs_wrap">
              <el-form-item label="图片/视频">
                <el-upload
                    name="files"
                    class="upload-demo"
                    :multiple="true"
                    :on-change="(file, fileList) => handleFileChange(3, file, fileList)"
                    :data="{upload_type: '3'}"
                    :on-success="(res, file, fileList) => handleFIleSuccess(3, res, file, fileList)"
                    :before-upload="(file) => beforeFileUpload(3, file)"
                    :before-remove="(file, fileList) => removeFileUpload(3, file, fileList)"
                    :on-preview="mi_upload_handlepreview"
                    :on-exceed="(files, fileList) => overFilelimit(3, files, fileList)"
                    :on-progress="handleFileUploadProgress"
                    :disabled="isUploading"
                    :file-list="caseFiles"
                    :action="pubPrefix+upload_url"
                    :headers="upload_headers"
                    :limit="20"
                    :show-file-list=false
                    accept=".jpg, .jpeg, .png, .mp4, .gif ">
                  <div slot="trigger" class="service_register_upload" style="height: 140px;" v-loading="isUploading" element-loading-text="文件上传中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
                    <i class="el-icon-circle-plus"></i>
                    <span>上传图片/视频</span>
                    <span class="service_register_upload_tip">支持图片JPG/JPEG/PNG/GIF格式
                      视频MP4格式
                      每个图片/视频不超过100M
                      最多上传20个</span>
                  </div>
                </el-upload>
              </el-form-item>
              <div class="service_register_upload_imgs">
                <div class="service_register_upload_item_wrap" v-for="(item, index) in caseFiles" :key="index">
                  <el-image v-if="item.suffix != 'mp4'" :src="item.url" class="service_register_upload_item" :preview-src-list="caseImgs">
                  </el-image>
                  <video v-else class=" service_register_upload_item" :controls="true" :src="item.url"></video>
                  <span @click="onDelete(3, index)" class="service_register_upload_item_delete"><img :src="require('@/assets/img/icon_off_deep.png')"/></span>
                </div>
              </div>
            </div>
            <el-form-item>
              <el-button style="height: 40px;padding: 9px 98px;" :loading="loadingbut" type="primary" @click="submitForm('ruleForm')">提交</el-button>
              <el-button style="height: 40px;padding: 9px 34px;" @click="cancelSub">取消</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>

    <el-dialog
        title="图片裁剪"
        :visible.sync="showCropper"
        center
        width="90%"
        :close-on-click-modal="false"
    >
      <div class="cropper-content">
        <div class="cropper-box">
          <div class="cropper">
            <vue-cropper ref="cropper" v-bind="cropOption" @real-time="realTime" @img-load="imgLoad"></vue-cropper>
          </div>
          <!--底部操作工具按钮1-->
          <div class="footer-btn">
            <div class="scope-btn">
              <label class="btn" for="uploads">选择图片</label>
              <input type="file" id="uploads" style="position:absolute; clip:rect(0 0 0 0);" accept="image/png,image/jpg"
                     @change="selectImg($event)">
              <el-button size="mini" type="danger" plain @click="changeScale(1)">放大</el-button>
              <el-button size="mini" type="danger" plain @click="changeScale(-1)">缩小</el-button>
              <el-button size="mini" type="danger" plain @click="rotateLeft">↺ 左旋转</el-button>
              <el-button size="mini" type="danger" plain @click="rotateRight">↻ 右旋转</el-button>
            </div>
            <div class="upload-btn">
              <el-button size="mini" type="success" @click="uploadImg">上传图片 <i class="el-icon-upload"></i></el-button>
            </div>
          </div>
        </div>
        <!--预览效果图-->
        <div class="show-preview">
          <div :style="previews.div" class="preview">
            <img :src="previews.url" :style="previews.img">
          </div>
        </div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
/* eslint-disable */
import Mainl from '@/components/Mainl.vue'
import store  from 'store'

// import CropperImage from '@/components/CropperImage.vue'
import { VueCropper } from 'vue-cropper'
// import axios from 'axios'
// import Cookies from 'js-cookie'
// eslint-disable-next-line
import * as commfun from '@/common/common.js'
import Cookies from 'js-cookie'
var pubPrefix = '/api'
export default {
  name: 'ServiceCaseAdd',
  components: {
    Mainl,
    VueCropper
    // CropperImage
  },
  data: function () {
    return {
      pubPrefix: pubPrefix,
      case_id: '',
      xy_case_money_dict: [], // 项目金额字典
      industry_dic: [], // 所属行业字典
      category_dic: [], // 创意类目字典
      status_dic: {1: '待审核', 2: '已通过', 3: '未通过'},
      upload_url: '/api/index/upload',
      upload_data: {},
      upload_headers: {},
      industry_info: [],
      category_info: [],
      ruleForm: {
        name: '',
        cycle: '',
        money: '',
        brand_name: '',
        industry_top_id: '',
        industry_top_name: '',
        industry_second_id: '',
        industry_second_name: '',
        category_top_id: '',
        category_top_name: '',
        category_second_id: '',
        category_second_name: '',
        service_content: ''
      },
      cover_url: '',  // 封面图片地址
      coverArr: [],
      caseFiles: [],
      caseImgs: [], // 图片放大的数组
      loadingbut: false,
      isUploading: false,
      cover_msg: '请上传尺寸为1280×720的封面图，支持JPG/JPEG/PNG文件，大小不超过10M',
      caseWhiteListUserId: [],  // L2024022101 teambition

      // 封面上传组件 - 组件
      fileNewList:[],
      fileSrcList:[],
      cropperOption: { // 裁剪配置
        img: '',
        autoCropWidth: 1280,
        autoCropHeight: 720
      },
      cropperStyle: { // 裁剪框大小
        width: '700px',
        height: '500px'
      },
      fileSize:1,//文件限制个数
      cropperData:{},
      coverFileInfo: {},
      // 封面上传组件 - 组件

      // 封面上传 - 非组件
      previews: {},
      showCropper: false, // 显示裁剪弹窗
      cropOption: {
        img: "",
        size: 1,
        outputSize: 1, // 裁剪生成图片的质量
        outputType: 'png', // 裁剪生成图片的格式
        full: true, // 是否输出原图比例的截图
        info: true, // 图片大小信息
        canScale: true, // 图片是否允许滚轮缩放
        autoCrop: true, // 是否默认生成截图框
        autoCropWidth: 1280, // 默认生成截图框宽度
        autoCropHeight: 720, // 默认生成截图框高度
        canMove: true, // 上传图片是否可以移动
        canMoveBox: true, // 截图框能否拖动
        fixedBox: false, // 固定截图框大小 不允许改变
        fixed: true, // 是否开启截图框宽高固定比例
        fixedNumber: [16, 9], // 截图框的宽高比例
        original: false, // 上传图片按照原始比例渲染
        centerBox: true, // 截图框是否被限制在图片里面
        height: true, // 是否按照设备的dpr 输出等比例图片
        infoTrue: true, // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
        enlarge: 1, // 图片根据截图框输出比例倍数
        mode: 'contain', // 图片默认渲染方式  contain , cover, 100px, 100% auto
        maxImgSize: 2000
      }
      // 封面上传 - 非组件

    }
  },
  created () {
    var queryString = window.location.search;
    var urlParams = new URLSearchParams(queryString);
    var case_id = urlParams.get('case_id');
    if (case_id != null && case_id != undefined && case_id != '') {
      this.case_id = case_id
    }
    // 获取字典数据
    this.getDict()

  },
  mounted () {
    // 获取token设置header
    var Authorization = commfun.genAuthorization()
    this.upload_headers = {'Authorization':Authorization}  // 'Content-type':'application/x-www-form-urlencoded;charset=utf-8',

  },
  methods: {
    // 获取字典
    getDict () {
      var selfthis = this
      var url = pubPrefix + '/api/case/dict'
      commfun.ajaxGet(selfthis, url, {}, function (selfthis, result) {
        selfthis.xy_case_money_dict = result.xy_case_money_dict
        selfthis.industry_dic = result.industry_dic
        selfthis.category_dic = result.category_dic
        selfthis.top_creative_categories_dict = result.top_creative_categories_dict
        if (selfthis.case_id != '') {
          selfthis.initData()
        }else{
          //获取缓存数据-表单
          var cache_ruleForm = store.get('service_case_add_ruleForm')
          if(cache_ruleForm != undefined && cache_ruleForm != null){
            selfthis.ruleForm = cache_ruleForm
          }
          //获取缓存数据-行业
          var cache_industry_info = store.get('service_case_add_industry_info')
          if(cache_industry_info != undefined && cache_industry_info != null){
            selfthis.industry_info = cache_industry_info
          }
          //获取缓存数据-创意类目
          var cache_category_info = store.get('service_case_add_category_info')
          if(cache_category_info != undefined && cache_category_info != null){
            selfthis.category_info = cache_category_info
          }
          //获取缓存数据-封面图
          var cache_coverArr = store.get('service_case_add_coverArr')
          if(cache_coverArr != undefined && cache_coverArr != null){
            selfthis.coverArr = cache_coverArr
            if (selfthis.coverArr.length > 0) {
              selfthis.cover_url = selfthis.coverArr[0].url
            }
          }
          //获取缓存数据-案例文件
          var cache_caseFiles = store.get('service_case_add_caseFiles')
          if(cache_caseFiles != undefined && cache_caseFiles != null){
            selfthis.caseFiles = cache_caseFiles
            if (selfthis.caseFiles.length > 0) {
              for (var i = 0; i < selfthis.caseFiles.length; i ++) {
                if (selfthis.caseFiles[i].suffix != 'mp4') {
                  selfthis.caseImgs.push(selfthis.caseFiles[i].url)
                }
              }
            }
          }
        }
      }, function (selfthis, result) {
        selfthis.$message({
          showClose: true,
          message: '字典查询错误，请联系管理员！',
          type: 'warning',
          customClass: 'zZindex'
        })
      })
    },
    // 案例数据
    initData: function () {
      var selfthis = this
      var url = pubPrefix + '/api/case/caseDetail'
      var postdata={
        case_id: this.case_id
      }
      commfun.ajaxPost(selfthis, url, postdata, function (selfthis, data) {
        if (data.case_white_id != undefined && data.case_white_id != null && data.case_white_id.length > 0) {
          selfthis.caseWhiteListUserId = data.case_white_id
        }
        selfthis.coverArr = data.case_cover
        if (selfthis.coverArr.length > 0) {
          selfthis.cover_url = selfthis.coverArr[0].url
        }
        selfthis.caseFiles = data.case_files
        if (selfthis.caseFiles.length > 0) {
          for (var i = 0; i < selfthis.caseFiles.length; i ++) {
            if (selfthis.caseFiles[i].suffix != 'mp4') {
              selfthis.caseImgs.push(selfthis.caseFiles[i].url)
            }
          }
        }
        for (var i in selfthis.ruleForm) {
          if (i in data.case_detail) {
            selfthis.ruleForm[i] = data.case_detail[i]
          }
        }
        selfthis.industry_info = []
        // 给行业默认选中
        if (data.case_detail.industry_top_id != '' && data.case_detail.industry_second_id != '') {
          selfthis.industry_info= data.case_detail.industry_top_id.split(',')
          // selfthis.industry_info.push(data.case_detail.industry_top_id)
          // selfthis.industry_info.push(data.case_detail.industry_second_id)
        }
        selfthis.category_info = []
        // 创意类目默认选中
        var category_second_id = []
        if (data.case_detail.category_second_id != '') {
          category_second_id = data.case_detail.category_second_id.split(',')
          for (var i in selfthis.category_dic) {
            var children = selfthis.category_dic[i].children
            for (var j in children) {
              var temp = []
              for (var k in category_second_id) {
                if (category_second_id[k] == children[j].value) {
                  temp.push(selfthis.category_dic[i].value)
                  temp.push(children[j].value)
                }
              }
              if (temp.length > 0) {
                selfthis.category_info.push(temp)
              }
            }
          }
        }
      }, function (selfthis, dataError) {
        commfun.showMessage(selfthis, 'warning', '错误：' + dataError.msg)
      })
    },
    // 行业选择
    industryChange(value){
      if (value.length > 0) {
        /*  // 这是二级行业的赋值方法
        this.ruleForm.industry_top_id = value[0]
        this.ruleForm.industry_second_id = value[1]
        for (var i in this.industry_dic) {
          if (value[0] == this.industry_dic[i].value) {
            this.ruleForm.industry_top_name = this.industry_dic[i].label
          }
          var children = this.industry_dic[i].children
          for (var j in children) {
            if (value[1] == children[j].value) {
              this.ruleForm.industry_second_name = children[j].label
            }
          }
        }
        */
        var industry_id = value.join(',')
        this.ruleForm.industry_top_id = industry_id
        this.ruleForm.industry_second_id = industry_id
        var industry_name = ''
        for (var i in value) {
          for (var j in this.industry_dic) {
            if (value[i] == this.industry_dic[j].value) {
              industry_name += this.industry_dic[j].label + ','
            }
          }
        }
        if (industry_name != '') {
          industry_name = industry_name.slice(0, -1);
        }
        this.ruleForm.industry_top_name = industry_name
        this.ruleForm.industry_second_name = industry_name
      } else {
        this.ruleForm.industry_top_id = ''
        this.ruleForm.industry_second_id = ''
        this.ruleForm.industry_top_name = ''
        this.ruleForm.industry_second_name = ''
      }
    },
    // 创意类目选择
    categoryChange (values) {
      if (values.length > 0) {
        var category_top_id = [],
            category_second_id = [],
            category_top_name = [],
            category_second_name = []
        for (var k in values) {
          if (!category_top_id.includes(values[k][0])) {
            category_top_id.push(values[k][0])
          }
          category_second_id.push(values[k][1])
          for (var i in this.category_dic) {
            if (values[k][0] == this.category_dic[i].value && !category_top_name.includes(this.category_dic[i].label)) {
              category_top_name.push(this.category_dic[i].label)
            }
            var children = this.category_dic[i].children
            for (var j in children) {
              if (values[k][1] == children[j].value) {
                category_second_name.push(children[j].label)
              }
            }
          }
        }
        this.ruleForm.category_top_id = category_top_id.join(',')
        this.ruleForm.category_second_id = category_second_id.join(',')
        this.ruleForm.category_top_name = category_top_name.join(',')
        this.ruleForm.category_second_name = category_second_name.join(',')
      } else {
        this.ruleForm.category_top_id = ''
        this.ruleForm.category_second_id = ''
        this.ruleForm.category_top_name = ''
        this.ruleForm.category_second_name = ''
      }
    },
    handleFileChange(index, file, fileList) {
    },//上传文件
    handleFileUploadProgress (event, file, fileList) {
      this.isUploading = true;
    },
    // 上传完成
    async handleFIleSuccess(index, res, file, fileList) {
      var selfthis = this
      if (index == 2) {  // 上传封面图胺片【现在改为截取组件得了】
        if (res.code != 1000) {
          fileList.pop()
          if (res.msg != undefined && res.msg != '') {
            this.$message.error(res.msg);
          }
          return false;
        }
        res.data.status="success"
        res.data.name=file.name
        res.data.url=res.data.fileurl
        res.data.type = index
        try {
          // await this.$refs.upload.validate(); // 等待图片宽高判断完成  // 加上这句话 不走下面了
          // 在这里处理上传成功后的逻辑
          selfthis.cover_url = res.data.fileurl
          selfthis.coverArr = []
          selfthis.coverArr.push(res.data)
        } catch (error) {
          // 图片宽高不满足条件，不做任何处理
        }
        selfthis.isUploading = false;
      } else {
        //等待所有文件都上传完成，这里注意fList是所有的文件（包含已上传的）
        if (fileList.every(v => v.status == 'success')) {
          //处理字段
          fileList.map(item => {
            if (item.response != undefined && item.response.code == 1000) {
              // 获取文件类型
              var suffix = selfthis.getFileType(item.response.data.annex)
              item.response.data.suffix = suffix
              item.response.data.url = item.response.data.fileurl
              if (suffix != 'mp4') {
                selfthis.caseImgs.push(item.response.data.url)
              }
              selfthis.caseFiles.push(item.response.data)
            } else if (item.response != undefined && item.response.code != 1000 && item.response.msg != '') {
              selfthis.$message.error(item.response.msg);
            }
          })
          selfthis.isUploading = false;
        }
      }
    },//handleFIleSuccess
    // 上传文件
    beforeFileUpload(index, file, fileList){
      // this.upload_data['_csrf-backend'] = csrfToken;
      const fileSuffix = file.name.substring(file.name.lastIndexOf(".") + 1);
      const whiteList = ["jpg", "jpeg", "png", "gif", "JPG", "JPEG", "PNG", "GIF"];
      if (index == 3) {
        whiteList.push('mp4')
        whiteList.push('MP4')
      }
      if (whiteList.indexOf(fileSuffix) === -1) {
        var msg = '只能上传jpg/jpeg/png/gif/mp4格式文件!'
        if (index == 2) {
          msg = this.cover_msg
        }
        this.$message.error(msg);
        return false;
      }else{
        const isLt2M = file.size / 1024 / 1024 < 200;
        if (!isLt2M) {
          if (index == 2) {
            this.$message.error(this.cover_msg);
          } else {
            this.$message.error('上传文件大小不能超过 100MB!');
          }
        }
        const isJPG = true;
        if(isJPG && isLt2M){
          // 判断图片宽高
          if (index == 2) {
            return new Promise((resolve, reject) => {
              const reader = new FileReader();
              reader.readAsDataURL(file);
              reader.onload = (event) => {
                const img = new Image();
                img.src = event.target.result;
                img.onload = () => {
                  const width = img.width;
                  const height = img.height;
                  var invalid_width = 1280
                  var invalid_height = 720
                  // 宽 1280 上下容差 10PX
                  if (width > (invalid_width + 10) || width < (invalid_width - 10)) {
                    this.$message.warning('封面图片宽度应为'+invalid_width+'PX，上下不超过10PX！');
                    reject();
                    return false
                  }
                  // 高 720 上下容差 10PX
                  if (height > (invalid_height + 10) || height < (invalid_height - 10)) {
                    this.$message.warning('封面图片高度应为'+invalid_height+'PX，上下不超过10PX！');
                    reject();
                    return false
                  }
                  // console.log(`图片宽度：${width}px，图片高度：${height}px`);
                  resolve();
                  return true
                }
              }
            });
          } else {
            return true
          }
        }else{
          return false;
        }
      }
    },//beforeFileUpload 上传文件
    // 移除文件
    removeFileUpload(index, file, fileList){

    },
    // 打开文件
    mi_upload_handlepreview:function(file){
      if(file.response){
        window.open(file.response.fileurl)
      }else{
        window.open(file.fileurl)
      }
    },
    // 限制文件个数
    overFilelimit(index, files, fileList){
      if (index == 2) {
        this.$message.error('最多上传1个附件!');
      } else if (index == 3) {
        this.$message.error('最多上传20个附件!');
      }
    },
    // 删除附件  2：封面图片  3：附件图片&视频
    onDelete(type, index = 0){
      if (type == 2) {  // 案例封面
        this.cover_url = ''
        this.coverArr = []
      } else if (type == 3) {
        if (index > -1 && index < this.caseFiles.length) {
          this.caseFiles.splice(index, 1);
          this.caseImgs = []
          for (var i = 0; i < this.caseFiles.length; i ++) {
            if (this.caseFiles[i].suffix != 'mp4') {
              this.caseImgs.push(this.caseFiles[i].url)
            }
          }
        }
      }
    },

    // 封面图上传组件
    handleCrop (file) {
      // 点击弹出剪裁框
      this.$nextTick(() => {
        if (this.canCropper) {
          this.cropperOption.img = window.URL.createObjectURL(file.raw)
          this.showCropper = this.canCropper
          this.coverFileInfo = file
        }
      })
    },
    beforeAvatarUpload (file) {
      // 上传前校验
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 10
      if (!isJPG) {
        this.$message.error('只能上传jpg/jpeg/png格式文件!')
      }
      if (!isLt2M) {
        this.$message.error('封面图片大小不能超过 10 MB!')
      }
      // 校验通过后显示裁剪框
      this.canCropper = isJPG && isLt2M
      return false
    },
    // 自定义封面上传方法
    /*  // 组件化上传方法
    async uploadImg (file, blob_data) {
      var selfthis = this
      let fileFormData = new FormData()
      fileFormData.append('files', file);
      fileFormData.append('upload_type', 2);
      // 移除上传组件带来的bug
      // document.getElementsByTagName('body')[0].removeAttribute('style')
      this.showCropper = false
      //调用上传文件接口 以及回调
      commfun.ajaxPost(selfthis, this.pubPrefix + this.upload_url, fileFormData, function (selfthis, data) {
        selfthis.cover_url = blob_data
        data.status="success"
        data.name=file.name
        data.url=data.fileurl
        data.type = 2
        selfthis.coverArr = []
        selfthis.coverArr.push(data)
      }, function (selfthis, dataError) {
        commfun.showMessage(selfthis, 'warning', '错误：' + dataError.msg)
      })
    },
    */

    /********非组件化上传封面弹框*********/
    //初始化函数
    imgLoad(msg) {
      // console.log("工具初始化函数=====" + msg)
    },
    onEditImg(){
      this.showCropper = true
    },
    //图片缩放
    changeScale(num) {
      num = num || 1
      this.$refs.cropper.changeScale(num)
    },
    //向左旋转
    rotateLeft() {
      this.$refs.cropper.rotateLeft()
    },
    //向右旋转
    rotateRight() {
      this.$refs.cropper.rotateRight()
    },
    //实时预览函数
    realTime(data) {
      this.previews = data
    },
    onCropperReady(...a) {
      // console.log(a, 'onCropperReady')
    },
    //选择图片
    selectImg(e) {
      let file = e.target.files[0]
      let reader = new FileReader()
      const type = file.type.split("/")[1]
      this.cropOption.outputType = type === 'jpg' ? 'jpeg' : type
      //转化为blob
      reader.onload = (e) => {
        let data
        if (typeof e.target.result === 'object') {
          data = window.URL.createObjectURL(new Blob([e.target.result]))
        } else {
          data = e.target.result
        }
        this.cropOption.img = data
      }
      this.coverFileInfo = file
      //转化为base64
      reader.readAsDataURL(file)
    },
    // 将base64转换为文件
    dataURLtoFile (dataurl, filename) {
      let arr = dataurl.split(',')
      let mime = arr[0].match(/:(.*?);/)[1]
      let bstr = atob(arr[1])
      let len = bstr.length
      let u8arr = new Uint8Array(len)
      while (len--) {
        u8arr[len] = bstr.charCodeAt(len)
      }
      return new File([u8arr], filename, { type: mime })
    },
    //上传图片
    uploadImg() {
      var selfthis = this
      var filename = this.coverFileInfo.name
      this.$refs.cropper.getCropData(blob_data => {
        let file = this.dataURLtoFile(blob_data, 'xiangyun_crop_' + filename) // 'images.png' // 生成和原文件一样的名称
        let fileFormData = new FormData()
        fileFormData.append('files', file);
        fileFormData.append('upload_type', 2);
        // 移除上传组件带来的bug
        // document.getElementsByTagName('body')[0].removeAttribute('style')
        this.showCropper = false
        //调用上传文件接口 以及回调
        commfun.ajaxPost(selfthis, this.pubPrefix + this.upload_url, fileFormData, function (selfthis, data) {
          selfthis.cover_url = blob_data
          data.status="success"
          data.name=file.name
          data.url=data.fileurl
          data.type = 2
          selfthis.coverArr = []
          selfthis.coverArr.push(data)
        }, function (selfthis, dataError) {
          commfun.showMessage(selfthis, 'warning', '错误：' + dataError.msg)
        })
      })
    },
    /********非组件化上传封面弹框*********/

    // 取消提交
    cancelSub () {
      window.location.href = '/servicecaselist'
    },
    submitForm(formName) {
      if (this.coverArr.length == 0) {
        this.$message.warning('请上传案例封面图片!')
        return
      }
      if (this.caseFiles.length == 0) {
        this.$message.warning('请上传案例图片或视频!')
        return
      }
      if (this.isUploading) {
        this.$message.warning('文件正在上传!')
        return
      }
      var selfthis = this
      this.$refs[formName].validate((valid, obj) => {
        if (valid) {
          //附件
          var case_cover = ''
          var case_files = ''
          var file_list = selfthis.coverArr
          if (file_list) {
            for (var j = 0; j < file_list.length; j++) {
              if (file_list[j]['url']) {
                file_list[j]['url1'] = encodeURIComponent(file_list[j]['url'])
                case_cover +=   file_list[j]['annex'] + '|' + file_list[j]['hash'] + '|' + file_list[j]['type'] + '|' + file_list[j]['filename'] + '|' + file_list[j]['filesize'] + '|' + file_list[j]['url1'] + '|' + file_list[j]['uid'] + '|' + file_list[j]['username'] + '|' + file_list[j]['datetime'] + ',';
              }
            }
            case_cover = case_cover.slice(0, case_cover.length - 1);
          }
          var file_list1 = selfthis.caseFiles
          if (file_list1) {
            for (var j = 0; j < file_list1.length; j++) {
              if (file_list1[j]['url']) {
                file_list1[j]['url1'] = encodeURIComponent(file_list1[j]['url'])
                case_files +=   file_list1[j]['annex'] + '|' + file_list1[j]['hash'] + '|' + file_list1[j]['type'] + '|' + file_list1[j]['filename'] + '|' + file_list1[j]['filesize'] + '|' + file_list1[j]['url1'] + '|' + file_list1[j]['uid'] + '|' + file_list1[j]['username'] + '|' + file_list1[j]['datetime'] + ',';
              }
            }
            case_files = case_files.slice(0, case_files.length - 1);
          }

          selfthis.ruleForm.case_cover = case_cover;
          selfthis.ruleForm.case_files = case_files;
          selfthis.ruleForm.case_id = selfthis.case_id
          //ajax请求
          var url = pubPrefix + '/api/case/addData'
          if (selfthis.case_id != '') {  // 编辑案例
            // 判断当前登录用户是否在案例人员白名单中，如果在则不提示，如果不在则提示
            var userId = Cookies.get("userId")
            if (selfthis.caseWhiteListUserId.length > 0 && selfthis.in_array(Number(userId), selfthis.caseWhiteListUserId)) {
              selfthis.loadingbut = true
              commfun.ajaxPost(selfthis, url, selfthis.ruleForm, function (selfthis, result) {
                selfthis.$message({
                  message: '案例编辑成功！',
                  type: 'success',
                  customClass: 'zZindex'
                });
                setTimeout(function () {
                  // location.reload()
                  location.href = "/servicecaselist"
                }, 1000);
              }, function (selfthis, result) {
                if (result.code != 1000) {
                  selfthis.loadingbut = false;
                  selfthis.$message({
                    showClose: true,
                    message: result.msg,
                    type: 'error',
                    customClass: 'zZindex'
                  });
                }
              })
            } else {
              selfthis.$confirm('保存后案例需要重新审核，是否保存', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                selfthis.loadingbut = true
                commfun.ajaxPost(selfthis, url, selfthis.ruleForm, function (selfthis, result) {
                  selfthis.$message({
                    message: '案例编辑成功！',
                    type: 'success',
                    customClass: 'zZindex'
                  });
                  setTimeout(function () {
                    // location.reload()
                    location.href = "/servicecaselist"
                  }, 1000);
                }, function (selfthis, result) {
                  if (result.code != 1000) {
                    selfthis.loadingbut = false;
                    selfthis.$message({
                      showClose: true,
                      message: result.msg,
                      type: 'error',
                      customClass: 'zZindex'
                    });
                  }
                })
              }).catch(() => {

              });
            }

          } else {  // 添加案例
            selfthis.loadingbut = true
            commfun.ajaxPost(selfthis, url, selfthis.ruleForm, function (selfthis, result) {
              selfthis.$message({
                message: '案例添加成功！',
                type: 'success',
                customClass: 'zZindex'
              });//
              store.remove('service_case_add_ruleForm')
              store.remove('service_case_add_industry_info')
              store.remove('service_case_add_category_info')
              store.remove('service_case_add_coverArr')
              store.remove('service_case_add_caseFiles')
              setTimeout(function () {
                // location.reload()
                location.href = "/servicecaselist"
              }, 1000);
            }, function (selfthis, result) {
              if (result.code != 1000) {
                selfthis.loadingbut = false;
                selfthis.$message({
                  showClose: true,
                  message: result.msg,
                  type: 'error',
                  customClass: 'zZindex'
                });
              }
            })
          }
        } else {
          var msg = '验证失败，请检查表单！';
          for(var field in obj){
            if (obj[field][0].message){
              msg = obj[field][0].message;
            }
            selfthis.$message({
              message:msg,
              type: 'warning',
              offset:200
            });
            return true;
          }
        }
      });
    },
    // 判断指定值是否在指定数组中
    in_array (search, array) {
      for (var i = 0; i < array.length; i++) {
        if (array[i] === search) {
          return true;
        }
      }
      return false;
    },
    mlogin: function (type) {
      if (type === 'example') {
        this.visible = true
      } else {
        this.visible2 = true
      }
    },
    scrollTo: function (type) { // 滚动到位置 锚点
      document.querySelector('#' + type).scrollIntoView(true)
    },
    // 获取文件后缀
    getFileType(fileName) {
      const lastDotIndex = fileName.lastIndexOf('.');
      return lastDotIndex !== -1 ? fileName.substring(lastDotIndex + 1) : '';
    }
  },
  watch: {
    ruleForm: {
      handler(newVal, oldVal) {
        if(this.case_id != ''){
          return
        }
        console.log('The ruleForm cache changed:', newVal);
        store.set('service_case_add_ruleForm', newVal);
      },
      deep: true // 如果需要深度监听对象内部属性的变化，设置deep为true
    },
    industry_info: {
      handler(newVal, oldVal) {
        if(this.case_id != ''){
          return
        }
        console.log('The industry_info cache changed:', newVal);
        store.set('service_case_add_industry_info', newVal);
      },
      deep: true // 如果需要深度监听对象内部属性的变化，设置deep为true
    },
    category_info: {
      handler(newVal, oldVal) {
        if(this.case_id != ''){
          return
        }
        console.log('The category_info cache changed:', newVal);
        store.set('service_case_add_category_info', newVal);
      },
      deep: true // 如果需要深度监听对象内部属性的变化，设置deep为true
    },
    coverArr:{
      handler(newVal, oldVal) {
        if(this.case_id != ''){
          return
        }
        console.log('The coverArr cache changed:', newVal);
        store.set('service_case_add_coverArr', newVal);
      },
      deep: true // 如果需要深度监听对象内部属性的变化，设置deep为true
    },
    caseFiles:{
      handler(newVal, oldVal) {
        if(this.case_id != ''){
          return
        }
        console.log('The caseFiles cache changed:', newVal);
        store.set('service_case_add_caseFiles', newVal);
      },
      deep: true // 如果需要深度监听对象内部属性的变化，设置deep为true
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ServiceCaseAdd.vue